const ADMIN_ROLES = new Set(["TENANT_ADMIN", "FACILITY_ADMIN", "SUPER_ADMIN"]);

/** True when the user has a tenant/facility/super admin role. */
export function isDashboardAdminRole(roles: string[]): boolean {
  return roles.some((role) => ADMIN_ROLES.has(role));
}

/** True when the user has the team leader role. */
export function isDashboardTeamLeadRole(roles: string[]): boolean {
  return roles.includes("TEAM_LEADER");
}

/** Whether the dashboard nav item should appear in the sidebar. */
export function canSeeDashboardNav(roles: string[] | undefined): boolean {
  if (!Array.isArray(roles) || roles.length === 0) return false;
  return isDashboardAdminRole(roles) || isDashboardTeamLeadRole(roles);
}

/** Role-specific dashboard route, or null when the user has no dashboard access. */
export function getDashboardPathForRoles(
  roles: string[] | undefined
): "/home" | "/team-dashboard" | null {
  if (!Array.isArray(roles) || roles.length === 0) return null;
  if (isDashboardAdminRole(roles)) return "/home";
  if (isDashboardTeamLeadRole(roles)) return "/team-dashboard";
  return null;
}
